import { Button, Stack } from 'react-bootstrap';
import { useActionsWaitlistMutation } from '../../../services/endpoints/schedule/waitlist';
// import { useToast } from '../../../context';
import { toast } from 'react-toastify';

// import { useToast } from '../../../context';
const WaitlistActionsCell = ({ row }: { row: any }) => {
  const [actionsWaitlistMutation] = useActionsWaitlistMutation();
  // const { addToast } = useToast();
  const handleDeny = async () => {
    try {
      const orderPayload = {
        id: Number(row.original.waitlists.id),
        action: 'deny'
      };
      const response = await actionsWaitlistMutation(orderPayload).unwrap();
      if (response) {
        toast.success('Waitlist action Deny completed!');
      } else {
        toast.error('Waitlist action Deny failed!');
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  const handleExpire = async () => {
    try {
      const orderPayload = {
        id: Number(row.original.waitlists.id),
        action: 'expire'
      };
      const response = await actionsWaitlistMutation(orderPayload).unwrap();
      if (response) {
        toast.success('Waitlist action expire completed!');
        window.location.reload();
      } else {
        toast.error('Waitlist action expire failed!');
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  const handleInvite = async () => {
    try {
      const orderPayload = {
        id: Number(row.original.waitlists.id),
        action: 'invite'
      };
      const response = await actionsWaitlistMutation(orderPayload).unwrap();
      if (response) {
        toast.success('Waitlist action Invite completed!');
        window.location.reload();
      } else {
        toast.error('Waitlist action Invite failed!');
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return (
    <Stack
      direction="horizontal"
      gap={2}
    >
      {row.original.waitlists.status === 'pending' && (
        <>
          <Button
            variant="danger"
            size="sm"
            onClick={handleDeny}
          >
            Deny
          </Button>
          <Button
            variant="success"
            size="sm"
            onClick={handleInvite}
          >
            Invite
          </Button>
        </>
      )}
      {row.original.waitlists.status === 'invited' && (
        <Button
          variant="secondary"
          size="sm"
          onClick={handleExpire}
        >
          Expire
        </Button>
      )}{' '}
      {row.original.waitlists.status === 'expired' && (
        <Button
          variant="success"
          size="sm"
          onClick={handleInvite}
        >
          Invite
        </Button>
      )}{' '}
      {row.original.waitlists.status === 'denied' && (
        <Button
          variant="success"
          size="sm"
          onClick={handleInvite}
        >
          Invite
        </Button>
      )}
    </Stack>
  );
};

export default WaitlistActionsCell;
